module.exports = __webpack_public_path__ + "img/bg-trailer.0b93f5cb.jpg";